import { motion } from "framer-motion";
import { Sustainability } from "@/components/nyla/Sustainability";
import { ImpactStat } from "@/components/nyla/ImpactStat";
import { CtaBanner } from "@/components/nyla/CtaBanner";
import { SEO } from "@/components/nyla/SEO";

const sustainabilityJsonLd = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Home", item: "https://nylaairwater.earth/" },
    { "@type": "ListItem", position: 2, name: "Sustainability", item: "https://nylaairwater.earth/sustainability" },
  ],
};

export default function SustainabilityPage() {
  return (
    <div data-testid="sustainability-page" className="pt-14">
      <SEO
        title="Sustainability — Cleaner Production, Cleaner Planet"
        description="Zero groundwater extraction, circular glass packaging, reverse logistics, and cleaner production. 1,000 people drinking Nyla saves 5 million litres of groundwater every year."
        path="/sustainability"
        keywords="sustainable water brand, groundwater conservation, eco-friendly packaging, glass bottle reverse logistics, circular packaging, water sustainability India"
        jsonLd={sustainabilityJsonLd}
      />
      <Sustainability />

      <section data-testid="commitment-section" className="py-24 md:py-32 bg-white">
        <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
          >
            <p className="text-xs md:text-sm tracking-[0.2em] uppercase font-semibold text-[#86868B] mb-6">Our Commitment</p>
            <h2 data-testid="commitment-heading" className="font-display text-4xl md:text-5xl leading-tight tracking-tight font-medium text-[#1D1D1F]">
              We don't produce excess. We produce exactly what is needed.
            </h2>
            <p className="mt-8 text-lg md:text-xl leading-relaxed text-[#86868B]">
              Our process was never retrofitted for the planet — it was born from it. Energy
              use is managed carefully to keep our footprint falling with every cycle. Waste
              is tracked, measured, and driven toward zero. And because our water comes from
              the sky, not the ground, every bottle leaves wells full and rivers flowing for
              the communities that depend on them.
            </p>
            <p className="mt-6 text-lg md:text-xl leading-relaxed text-[#86868B]">
              Our packaging is 100% recyclable today, with an active transition to full
              glass under way — and a product lifecycle designed from bottle to return, so
              reuse and recycling happen at scale, not as an afterthought.
            </p>
          </motion.div>
        </div>
      </section>

      <ImpactStat />
      <CtaBanner />
    </div>
  );
}
